// MOMKIS - Fiche produit : sélecteur d'offre (1/2/3 unités).
//
// Principes :
// - Les paliers (titre/sous-titre/badge/quantité) et les couleurs viennent
//   entièrement du Liquid (settings de bloc + product.options_with_values /
//   product.variants réels) : rien n'est inventé ici.
// - Le prix affiché et le total ajouté au panier sont TOUJOURS calculés à
//   partir du vrai prix Shopify de chaque variante réellement sélectionnée
//   (variant.price, en centimes, tel que fourni par Liquid), jamais d'un
//   prix codé en dur. Le formatage réutilise shop.money_format (vrai
//   format configuré côté Shopify), pas une devise supposée.
// - L'ajout au panier utilise l'Ajax Cart API native (/cart/add.js,
//   items[]) puis réutilise les méthodes PUBLIQUES déjà exposées par
//   <cart-drawer>/<cart-notification> (getSectionsToRender/renderContents),
//   exactement comme assets/product-form.js le fait pour un ajout simple —
//   aucune logique de panier réimplémentée, un seul état de panier réel.

(function () {
  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Implémentation standard Shopify de formatage monétaire à partir d'un
  // format réel (shop.money_format), appliquée à un montant réel en
  // centimes. Ne fabrique aucune devise ni séparateur : reflète uniquement
  // la configuration Shopify existante.
  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var value = (number / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : value + formatString;
  }

  function findVariant(variants, colorPosition, colorName, baseVariant) {
    return (
      variants.find(function (v) {
        for (var i = 1; i <= 3; i++) {
          var key = 'option' + i;
          if (v[key] === undefined || v[key] === null) continue;
          var expected = i === colorPosition ? colorName : baseVariant && baseVariant[key];
          if (expected != null && v[key] !== expected) return false;
        }
        return true;
      }) || null
    );
  }

  function setupOffer(root) {
    var colorValues = parseJSON(root.querySelector('[data-momkis-color-values]')) || [];
    var variants = parseJSON(root.querySelector('[data-momkis-variants-json]')) || [];
    var colorPosition = parseInt(root.getAttribute('data-color-option-position'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}} €';
    var unitLabel = root.getAttribute('data-unit-label') || 'Article';
    var instance = root.getAttribute('data-instance');

    var baseVariant =
      variants.find(function (v) {
        return v.available;
      }) || variants[0] || null;

    var unitsWrap = root.querySelector('[data-momkis-offer-units]');
    var unitTemplate = root.querySelector('[data-momkis-unit-template]');
    var errorEl = root.querySelector('[data-momkis-offer-error]');
    var submitBtn = root.querySelector('[data-momkis-offer-submit]');
    var tierInputs = Array.prototype.slice.call(root.querySelectorAll('input[data-momkis-tier-quantity]'));

    var units = []; // { color: String|null, variant: Object|null }

    // Synchronise la galerie avec la variante dont la pastille vient d'être
    // cliquée.
    //
    // Ce produit a le réglage natif Dawn "hide_variants" activé
    // (templates/product.momkis.json) : à tout instant, le DOM de la galerie
    // ne contient QUE le média de la variante actuellement sélectionnée +
    // les médias génériques — jamais les 5 autres couleurs en même temps
    // (vérifié en runtime : sur 12 médias au total, seuls 6-7 sont présents
    // dans le DOM au chargement). C'est le réglage merchandising voulu (la
    // galerie ne doit jamais mélanger plusieurs coloris à la fois) : appeler
    // simplement media-gallery.setActiveMedia() avec l'ID d'un média absent
    // du DOM ne fait donc rien (repli silencieux sur le premier média
    // trouvé, cf. assets/media-gallery.js).
    //
    // Le flux natif Dawn (product-info.js, sélecteur de variante classique)
    // gère déjà exactement ce cas : à chaque changement de variante, il
    // récupère le HTML de CETTE section pour la nouvelle variante (Section
    // Rendering API, `?variant=X&section_id=Y`) puis fusionne son
    // media-gallery dans le DOM courant (ajoute le média manquant, retire
    // celui qui ne correspond plus, réordonne, réactive le zoom) via sa
    // méthode `updateMedia(html, featuredMediaId)`. On réutilise cette
    // méthode PUBLIQUE telle quelle sur l'instance <product-info> déjà
    // présente sur la page — aucune logique de fusion de galerie
    // réimplémentée, aucune table couleur → image codée en dur.
    var variantHtmlCache = {}; // variant.id -> Promise<Document>
    var latestRequestedVariantId = null;

    // media-gallery.js: setActiveMedia() fait defiler la PAGE (window.scrollTo,
    // behavior:'smooth') des qu'elle juge le media actif "hors ecran"
    // (activeMediaRect.top <= -0.5) — vrai en permanence ici puisque
    // l'utilisateur clique une pastille couleur en etant deja descendu au
    // niveau du buybox, bien en dessous de la galerie. Ce comportement est
    // voulu par Dawn pour un changement de variante en pleine page (on
    // ramene l'utilisateur vers le nouveau media), mais ne convient pas a
    // notre selecteur de couleur MOMKIS : on veut synchroniser la galerie en
    // arriere-plan sans jamais deplacer verticalement l'utilisateur. Aucun
    // parametre de setActiveMedia() ne permet de desactiver ce scroll, et
    // media-gallery.js est un asset PARTAGE par toute la galerie Dawn (y
    // compris d'autres usages ou ce comportement reste souhaitable) : on ne
    // le modifie donc pas globalement. On neutralise uniquement l'UNIQUE
    // appel window.scrollTo declenche PAR NOTRE PROPRE appel, en le
    // remplacant temporairement par un no-op le temps strictement necessaire
    // (setActiveMedia planifie son scroll via son propre
    // window.setTimeout(...,0) interne ; la restauration ci-dessous est donc
    // elle aussi plannifiee via setTimeout(...,0), pour s'executer juste
    // apres dans le meme tour de boucle d'evenements — jamais de patch
    // laisse actif au-dela de cet appel precis). Le scroll HORIZONTAL du
    // slider (Element.scrollTo sur le conteneur de la liste de medias, une
    // methode distincte de window.scrollTo) n'est pas touche : il continue
    // de fonctionner normalement pour amener le bon slide dans le cadre.
    function callSuppressingPageScroll(fn) {
      var originalWindowScrollTo = window.scrollTo;
      var originalWindowScroll = window.scroll;
      window.scrollTo = function () {};
      window.scroll = function () {};
      try {
        fn();
      } finally {
        window.setTimeout(function () {
          window.scrollTo = originalWindowScrollTo;
          window.scroll = originalWindowScroll;
        }, 0);
      }
    }

    function fetchVariantHtml(variant) {
      if (variantHtmlCache[variant.id]) return variantHtmlCache[variant.id];
      var productInfo = document.querySelector('product-info');
      var baseUrl = (productInfo && productInfo.dataset.url) || window.location.pathname;
      var url = baseUrl + '?variant=' + variant.id + '&section_id=' + instance;
      var promise = fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          return new DOMParser().parseFromString(text, 'text/html');
        });
      variantHtmlCache[variant.id] = promise;
      return promise;
    }

    function syncGalleryToVariant(variant) {
      if (!variant || !variant.featuredMediaId) return;
      var productInfo = document.querySelector('product-info');
      if (!productInfo || typeof productInfo.updateMedia !== 'function') return;

      latestRequestedVariantId = variant.id;

      var mediaId = instance + '-' + variant.featuredMediaId;
      var alreadyInDom = document.querySelector('.momkis-pdp-hero__gallery [data-media-id="' + mediaId + '"]');

      if (alreadyInDom) {
        var gallery = document.querySelector('.momkis-pdp-hero__gallery media-gallery');
        if (gallery && typeof gallery.setActiveMedia === 'function') {
          callSuppressingPageScroll(function () {
            gallery.setActiveMedia(mediaId, false);
          });
        }
        return;
      }

      fetchVariantHtml(variant)
        .then(function (html) {
          // Une couleur plus récente a pu être cliquée pendant le fetch
          // (changement rapide entre plusieurs couleurs) : on ignore alors
          // cette réponse devenue obsolète pour ne jamais l'appliquer après
          // coup par-dessus la couleur réellement choisie en dernier.
          if (latestRequestedVariantId !== variant.id) return;
          callSuppressingPageScroll(function () {
            productInfo.updateMedia(html, variant.featuredMediaId);
          });

          // Filet de sécurité : sur clics très rapprochés, il est arrivé que
          // la fusion DOM native (product-info.js updateMedia) ne rende pas
          // le média actif à temps si un appel précédent était encore en
          // cours de traitement. On vérifie juste après, et si l'ID cible
          // n'est toujours pas actif alors qu'il est bien présent dans le
          // DOM (fusion réussie mais setActiveMedia raté), on ré-active
          // explicitement via l'API native — sans nouvel appel réseau.
          window.setTimeout(function () {
            if (latestRequestedVariantId !== variant.id) return;
            var isActive = document.querySelector(
              '.momkis-pdp-hero__gallery [data-media-id="' + mediaId + '"].is-active'
            );
            if (isActive) return;
            var target = document.querySelector('.momkis-pdp-hero__gallery [data-media-id="' + mediaId + '"]');
            var gallery = document.querySelector('.momkis-pdp-hero__gallery media-gallery');
            if (target && gallery && typeof gallery.setActiveMedia === 'function') {
              callSuppressingPageScroll(function () {
                gallery.setActiveMedia(mediaId, false);
              });
            }
          }, 150);
        })
        .catch(function () {});
    }

    function currentQuantity() {
      var checked = tierInputs.filter(function (i) {
        return i.checked;
      })[0];
      return checked ? parseInt(checked.value, 10) : 0;
    }

    function checkedTierElement() {
      var checked = tierInputs.filter(function (i) {
        return i.checked;
      })[0];
      return checked ? checked.closest('.momkis-pdp-offer__tier') : null;
    }

    // Remise réelle automatic_discount, par ordre de priorité :
    // 1. "Prix promo réel affiché" (display_discounted_price) : le montant
    //    exact que le marchand a vérifié dans son propre panier Shopify.
    //    Fiable UNIQUEMENT si le sous-total réel des unités sélectionnées
    //    correspond au scénario de référence (variante de base × quantité)
    //    pour lequel ce prix a été vérifié — sinon un client choisissant
    //    des couleurs à prix différents verrait un montant qui ne
    //    correspondrait plus à ce que Shopify facturerait réellement.
    // 2. À défaut (ou si le sous-total diverge), repli sur le calcul au
    //    pourcentage, arrondi AU CENTIME PAR UNITÉ puis sommé (Shopify
    //    arrondit ligne par ligne dans le panier, jamais une seule fois sur
    //    le total agrégé).
    // 3. Sinon, aucun prix promo affiché — jamais un montant inventé.
    function applyDiscount(unitPrices, tierEl) {
      var subtotal = unitPrices.reduce(function (sum, price) {
        return sum + price;
      }, 0);

      var mode = tierEl ? tierEl.getAttribute('data-discount-mode') : 'none';
      if (mode !== 'automatic_discount') {
        return { main: subtotal, compare: null, savings: null };
      }

      var qty = unitPrices.length;
      var baselineSubtotal = baseVariant ? baseVariant.price * qty : subtotal;

      var manualRaw = tierEl ? tierEl.getAttribute('data-display-discounted-price') : null;
      var manualCents = manualRaw ? Math.round(parseFloat(manualRaw) * 100) : 0;

      if (manualCents > 0 && manualCents < subtotal && subtotal === baselineSubtotal) {
        return { main: manualCents, compare: subtotal, savings: subtotal - manualCents };
      }

      var pct = tierEl ? parseFloat(tierEl.getAttribute('data-discount-percentage')) || 0 : 0;
      if (pct > 0) {
        var discountedTotal = unitPrices.reduce(function (sum, price) {
          return sum + Math.round(price * (1 - pct / 100));
        }, 0);
        return { main: discountedTotal, compare: subtotal, savings: subtotal - discountedTotal };
      }

      return { main: subtotal, compare: null, savings: null };
    }

    function updateTierPreviewPrices() {
      var selectedQuantity = currentQuantity();
      var selectedReady = allUnitsReady() && units.length === selectedQuantity && selectedQuantity > 0;
      var selectedUnitPrices = selectedReady
        ? units.map(function (u) {
            return u.variant.price;
          })
        : null;

      tierInputs.forEach(function (input, index) {
        var qty = parseInt(input.value, 10) || 0;
        var tierEl = input.closest('.momkis-pdp-offer__tier');
        if (!tierEl || !baseVariant) return;

        // Prix réels une fois les couleurs de CE palier choisies, sinon
        // estimation à partir de la variante de base répétée `qty` fois
        // (recalculé automatiquement si les variantes sélectionnées ont
        // des prix différents, puisque le vrai prix de chaque unité est
        // utilisé dès qu'il est connu).
        var unitPrices = input.checked && selectedUnitPrices ? selectedUnitPrices : new Array(qty).fill(baseVariant.price);
        var pricing = applyDiscount(unitPrices, tierEl);

        var priceEl = tierEl.querySelector('[data-momkis-tier-price]');
        if (priceEl) priceEl.textContent = formatMoney(pricing.main, moneyFormat);

        var compareEl = tierEl.querySelector('[data-momkis-tier-compare]');
        if (compareEl) {
          compareEl.textContent = pricing.compare != null ? formatMoney(pricing.compare, moneyFormat) : '';
        }

        var savingsEl = tierEl.querySelector('[data-momkis-tier-savings]');
        if (savingsEl) {
          var override = savingsEl.getAttribute('data-momkis-override');
          if (override) {
            savingsEl.textContent = override;
          } else if (pricing.savings != null) {
            savingsEl.textContent = 'Économisez ' + formatMoney(pricing.savings, moneyFormat);
          } else {
            savingsEl.textContent = '';
          }
        }
      });
    }

    function renderUnits(quantity) {
      if (!unitsWrap || !unitTemplate) {
        // Pas d'option couleur sur ce produit : rien à choisir par unité.
        units = [];
        for (var n = 0; n < quantity; n++) units.push({ color: null, variant: baseVariant });
        refresh();
        return;
      }

      unitsWrap.innerHTML = '';
      units = [];

      for (let i = 0; i < quantity; i++) {
        // `let` est indispensable ici : ces variables sont capturées par les
        // listeners "change" créés ci-dessous, qui ne s'exécutent qu'après
        // la fin de CETTE boucle (au clic de l'utilisateur). Avec `var`
        // (portée fonction), tous les listeners partageaient la même
        // variable et lisaient sa DERNIÈRE valeur : sélectionner une couleur
        // sur n'importe quel article écrivait toujours dans le dernier
        // article du tableau `units`, laissant les précédents à
        // { variant: null } — d'où le CTA bloqué en désactivé même une fois
        // toutes les couleurs choisies.
        let unitIndex = i;
        var fragment = unitTemplate.content.cloneNode(true);
        var label = fragment.querySelector('.momkis-pdp-offer__unit-label');
        var group = fragment.querySelector('.momkis-pdp-offer__unit-swatches');
        var groupLabel = unitLabel + ' ' + (i + 1);
        if (label) label.textContent = groupLabel;
        if (group) {
          group.setAttribute('role', 'radiogroup');
          group.setAttribute('aria-label', groupLabel);
        }

        colorValues.forEach(function (colorValue, colorIndex) {
          var variant = findVariant(variants, colorPosition, colorValue.name, baseVariant);
          var available = !!(variant && variant.available);
          var inputId = 'MomkisOfferSwatch-' + instance + '-' + unitIndex + '-' + colorIndex;

          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'momkis-offer-unit-' + instance + '-' + unitIndex;
          input.id = inputId;
          input.value = colorValue.name;
          if (!available) input.disabled = true;

          var swatchLabel = document.createElement('label');
          swatchLabel.setAttribute('for', inputId);
          swatchLabel.className = 'momkis-swatch';
          swatchLabel.setAttribute('aria-label', colorValue.name);

          if (colorValue.swatch_color) {
            swatchLabel.style.backgroundColor = 'rgb(' + colorValue.swatch_color + ')';
          } else {
            var mapped = (window.MOMKIS_COLOR_MAP || {})[colorValue.name.toLowerCase()];
            if (mapped) swatchLabel.style.backgroundColor = mapped;
          }

          input.addEventListener('change', function () {
            units[unitIndex] = { color: colorValue.name, variant: variant };
            syncGalleryToVariant(variant);
            refresh();
          });

          if (group) {
            group.appendChild(input);
            group.appendChild(swatchLabel);
          }
        });

        units.push({ color: null, variant: null });
        unitsWrap.appendChild(fragment);
      }

      refresh();
    }

    function allUnitsReady() {
      if (!units.length) return false;
      return units.every(function (u) {
        return u.variant && u.variant.available;
      });
    }

    function unitPricesArray() {
      return units.map(function (u) {
        return u.variant ? u.variant.price : 0;
      });
    }

    function ctaBaseLabel(quantity) {
      if (quantity <= 1) return 'Ajouter au panier';
      return 'Ajouter les ' + quantity + ' au panier';
    }

    // "En stock" tant qu'aucune sélection en cours n'est réellement
    // indisponible (les unités pas encore choisies n'ont pas d'avis sur la
    // question) ; "Indisponible" dès qu'une variante choisie ne l'est pas.
    // Jamais de quantité de stock inventée (pas de "Plus que X").
    function computeStockAvailable() {
      return units.every(function (u) {
        return !u.variant || u.variant.available;
      });
    }

    // Bloc prix principal de la buybox : même fonction applyDiscount() que
    // les cartes de palier / CTA / sticky, aucun second calcul. Avant que
    // toutes les couleurs d'un palier soient choisies, affiche une
    // estimation à partir de la variante de base (identique à l'aperçu des
    // cartes de palier).
    function updateMainPriceBlock() {
      // `document`, pas `root` : le bloc prix/stock est rendu par Liquid
      // comme un FRÈRE de .momkis-pdp-offer (deux blocs "{% if
      // has_offer_tiers %}" distincts côte à côte dans la buybox), pas un
      // descendant. root.querySelector(...) ne l'atteignait donc jamais et
      // la fonction s'arrêtait immédiatement à la ligne suivante — c'est ce
      // qui laissait aussi bien le prix principal que le label de stock
      // vides depuis le début, malgré le point de statut (rendu en dur par
      // Liquid, lui, donc toujours visible).
      var priceBlock = document.querySelector('[data-momkis-price-block]');
      if (!priceBlock || !baseVariant) return;

      var quantity = currentQuantity();
      var ready = allUnitsReady() && units.length === quantity && quantity > 0;
      var unitPrices = ready ? unitPricesArray() : new Array(quantity || 1).fill(baseVariant.price);
      var pricing = applyDiscount(unitPrices, checkedTierElement());

      var mainEl = priceBlock.querySelector('[data-momkis-price-main]');
      if (mainEl) mainEl.textContent = formatMoney(pricing.main, moneyFormat);

      // État explicitement réinitialisé dans les deux branches (rempli ET
      // masqué) à chaque refresh() — jamais seulement "hidden = true" sans
      // vider le texte, pour ne laisser aucun résidu visuel/DOM du palier
      // précédent en cas de changement futur de CSS ou de lecteur d'écran
      // qui ignorerait l'attribut hidden.
      var compareEl = priceBlock.querySelector('[data-momkis-price-compare]');
      if (compareEl) {
        if (pricing.compare != null) {
          compareEl.textContent = formatMoney(pricing.compare, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      var savingsEl = document.querySelector('[data-momkis-price-savings]');
      if (savingsEl) {
        if (pricing.savings != null && pricing.savings > 0) {
          savingsEl.textContent = 'Économisez ' + formatMoney(pricing.savings, moneyFormat);
          savingsEl.hidden = false;
        } else {
          savingsEl.textContent = '';
          savingsEl.hidden = true;
        }
      }

      var stockWrap = document.querySelector('[data-momkis-stock]');
      var stockLabel = document.querySelector('[data-momkis-stock-label]');
      if (stockWrap && stockLabel) {
        var available = computeStockAvailable();
        stockWrap.classList.toggle('is-unavailable', !available);
        stockLabel.textContent = available ? 'En stock' : 'Indisponible';
      }
    }

    function refresh() {
      var quantity = currentQuantity();
      updateTierPreviewPrices();
      updateMainPriceBlock();

      var ready = allUnitsReady() && units.length === quantity && quantity > 0;
      var label = ctaBaseLabel(quantity);

      if (ready) {
        var pricing = applyDiscount(unitPricesArray(), checkedTierElement());
        label += ' — ' + formatMoney(pricing.main, moneyFormat);
      }

      setCtaState(ready, label);

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function setCtaState(ready, label) {
      var mirrors = document.querySelectorAll('[data-momkis-offer-submit], [data-momkis-offer-submit-mirror]');
      mirrors.forEach(function (btn) {
        btn.disabled = !ready;
        var labelTarget = btn.querySelector('[data-momkis-cta-label]');
        if (labelTarget) labelTarget.textContent = label;
      });

      var stickyName = document.querySelector('[data-momkis-sticky-name]');
      if (stickyName) {
        var quantity = currentQuantity();
        var baseName = stickyName.getAttribute('data-momkis-base-name');
        if (!baseName) {
          baseName = stickyName.textContent.trim();
          stickyName.setAttribute('data-momkis-base-name', baseName);
        }
        stickyName.textContent = quantity > 1 ? quantity + ' × ' + baseName : baseName;
      }

      var stickyPrice = document.querySelector('[data-momkis-sticky-price]');
      if (stickyPrice && ready) {
        var stickyPricing = applyDiscount(unitPricesArray(), checkedTierElement());
        stickyPrice.textContent = formatMoney(stickyPricing.main, moneyFormat);
      }
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function submitOffer() {
      if (!allUnitsReady()) return;

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var items = units.map(function (u) {
        return { id: u.variant.id, quantity: 1 };
      });

      var mirrors = document.querySelectorAll('[data-momkis-offer-submit], [data-momkis-offer-submit-mirror]');
      mirrors.forEach(function (btn) {
        btn.disabled = true;
        btn.classList.add('loading');
      });

      var body = { items: items };
      if (cart) {
        body.sections = cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            var message = response.description || response.message || 'Une erreur est survenue.';
            showError(message);
            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'momkis-offer',
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            return;
          }

          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'momkis-offer',
              cartData: response,
            });
          }

          if (cart) {
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function () {
          showError('Une erreur réseau est survenue. Merci de réessayer.');
        })
        .finally(function () {
          mirrors.forEach(function (btn) {
            btn.classList.remove('loading');
          });
          refresh();
        });
    }

    tierInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        renderUnits(currentQuantity());
      });
    });

    var mirrors = document.querySelectorAll('[data-momkis-offer-submit], [data-momkis-offer-submit-mirror]');
    mirrors.forEach(function (btn) {
      btn.addEventListener('click', submitOffer);
    });

    var initialQuantity = currentQuantity();
    if (initialQuantity > 0) renderUnits(initialQuantity);
    else refresh();
  }

  function init() {
    document.querySelectorAll('[data-momkis-offer]').forEach(setupOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
